import { StateCreator } from "zustand";
import { IAppState, ISongRequestStats, IStatsState } from '../types';

const createStatsSlice: StateCreator<
    IAppState,
    [["zustand/devtools", never], ["zustand/persist", unknown], ["zustand/immer", never]],
    [],
    IStatsState
    > = (set, get) => {
    return {
        stats: {
            songRequest: {
                modify: 0,
                file: 0,
                total: 0,
            }
        },
        setSongRequestStats: (values: ISongRequestStats): void => {
            set(state => {
                state.stats.songRequest = values;
            })
        }
    }
};

export default createStatsSlice;